import config from '../../config.json'

class ConfigProvider {
  config = config.data
}

export default new ConfigProvider()
